/**
 * vuex mutations
*/
import {
  deepMerge
} from "@/common/js/utils";
import * as types from "./mutation-types";

const mutations = {
  // 设置tokenName
  [types.SET_TOKEN_NAME](state, tokenName){
    state.tokenName = tokenName;
  },
  // 设置token
  [types.SET_TOKEN](state, token){
    state.token = token;
  },
  // 设置lang
  [types.SET_LANG](state, lang){
    state.lang = lang;
  },
  // 设置用户信息
  [types.SET_USER_INFO](state, userInfo){
    state.userInfo = deepMerge({},userInfo);
  },
  // 设置用户ID
  [types.SET_USER_ID](state, id){
    state.id = id;
  },
  // 设置用户tag
  [types.SET_USER_TAGS](state, tags){
    state.userTags = deepMerge([],tags);
  },
  // 设置消息未读数
  [types.SET_UNREAD_COUNT](state, unreadCount){
    state.unreadCount = deepMerge([],unreadCount);
  },
  // 设置系统消息未读数
  [types.SET_SYSTEM_UNREAD_COUNT](state, unreadSystemCount){
    state.unreadSystemCount = unreadSystemCount;
  },
  // 设置客服消息未读数
  [types.SET_CUSTOMER_UNREAD_COUNT](state, unreadCustomerCount){
    state.unreadCustomerCount = unreadCustomerCount;
  },
  // 设置群组客服消息未读数
  [types.SET_GROUPS_UNREAD_TOTAL_COUNT](state, unreadGroupsTotalCount=0){
    state.unreadGroupsTotalCount = unreadGroupsTotalCount;
  },

  // 设置伸缩
  [types.SET_COLLAPSE](state, collapse){
    state.collapse = collapse;
  },
  // 设置可编辑tabs的内容
  [types.SET_EDITABLE_TABS](state, editableTabs){
    state.editableTabs = deepMerge([],editableTabs);
  },
  // 设置当前选中值
  [types.SET_EDITABLE_TABS_VALUE](state, editableTabsValue){
    state.editableTabsValue = editableTabsValue;
  },
  // 设置菜单
  [types.SET_MENULISTS](state, menuLists){
    state.menuLists = deepMerge([],menuLists);
  }
}

export default mutations;
